import Link from "next/link";

const steps = [
  {
    step: "01",
    title: "Discovery sprint",
    desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint.",
  },
  {
    step: "02",
    title: "Build",
    desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation.",
  },
  {
    step: "03",
    title: "Operate",
    desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery.",
  },
];

export default function MethodologyAnchor() {
  return (
    <section className="px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100">
      <div className="max-w-5xl">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">How an engagement works</h2>
        <p className="text-gray-500 mb-10 text-base">
          No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map(s => (
            <div key={s.step} className="flex flex-col gap-3">
              <span className="text-3xl font-bold text-[#f1aa4e]">{s.step}</span>
              <h3 className="text-lg font-semibold text-gray-900">{s.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-10">
          <Link href="/itmtb-how-we-work">
            <a className="text-blue-600 font-semibold text-sm hover:underline">
              Full methodology and engagement shapes →
            </a>
          </Link>
        </div>
      </div>
    </section>
  );
}
